import type { RegionDetail } from '../../../../api/regions';

/**
 * A subregion has no director of its own to set: directors attach top-level and
 * cover the whole territory beneath (BON-449). Show whose territory this is,
 * and where that comes from, instead of an editable field that cannot be saved.
 */
export function InheritedDirector({ detail }: { detail: RegionDetail }) {
  if (detail.inheritedDirectorName === null) {
    return (
      <div style={{ fontSize: 12, color: 'var(--nb-text-muted)' }}>
        No director on {detail.parentName ?? 'the parent region'} yet.
      </div>
    );
  }
  return (
    <div style={{ fontSize: 12 }}>
      <div>{detail.inheritedDirectorName}</div>
      <div style={{ color: 'var(--nb-text-muted)', marginTop: 2 }}>
        Inherited from {detail.inheritedFromRegionName}. Set the director there to change it.
      </div>
    </div>
  );
}
